/* eslint-disable no-unused-vars */
/* eslint-disable jsx-a11y/anchor-is-valid */
import React from 'react';
import { styled } from '@mui/system';
import PropTypes from 'prop-types';

import { Container, Box, Typography } from '@mui/material';

import Dashboard from '../Dashboard';
import Questions from '../Questions';

const MainWrapper = styled(Box, {})(({ theme }) => ({
    // backgroundColor: 'lightgreen',
    width: 'calc(100% - 250px)',
    marginLeft: '250px',
    // height: '100vh',
    // overflow: 'auto',
    padding: '40px 10px 40px 10px',
    h1: {
        marginBottom: '20px',
    },
}));

const Main = ({ group, percentageChecked }) => (
    <MainWrapper>
        <Container maxWidth="xl">
            <Typography variant="h1">
                {group}
            </Typography>
        </Container>
        {group === 'General' && (<Dashboard percentageChecked={percentageChecked} />)}
        {group !== 'General' && (<Questions group={group} percentageChecked={percentageChecked} />)}
    </MainWrapper>
);

Main.propTypes = {
    group: PropTypes.string,
    percentageChecked: PropTypes.bool,
};

Main.defaultProps = {
    group: '',
    percentageChecked: true,
};

export default Main;
